import { __rest } from "tslib";
import * as React from 'react';
import { isRowExpanded } from '@patternfly/react-table';
import { showIdWarnings } from '../../utils';
const resolveCascadeEditability = (rows) => {
    // eslint-disable-next-line no-undef
    const isRowExpandedIndexes = new Set(rows.map((row, idx) => (isRowExpanded(row, rows) ? idx : null)).filter(row => row !== null));
    // flag parents and their children which are edited together
    rows
        .filter((row, idx) => row.parent !== undefined &&
        row.isEditing &&
        isRowExpandedIndexes.has(idx) &&
        row.isEditableTogetherWithParent &&
        rows[row.parent].isEditing)
        .forEach(row => {
        rows[row.parent].isChildEditing = true;
        row.isParentEditing = true;
    });
    const lastVisibleRow = rows.filter((row, idx) => !row.parent || isRowExpandedIndexes.has(idx)).pop();
    // flag last parent row if there are only descendants under it
    if (lastVisibleRow && lastVisibleRow.isParentEditing) {
        let parentRow = lastVisibleRow;
        while (parentRow.parent !== undefined && parentRow.isEditableTogetherWithParent) {
            parentRow = rows[parentRow.parent];
        }
        parentRow.isLastVisibleParent = true;
    }
};
const onRow = (event, row, rowProps, computedData, { onRowClick, editConfig }) => {
    const target = event.target;
    const cell = target.closest('[data-key]');
    // eslint-disable-next-line radix
    const cellNumber = parseInt(cell && cell.getAttribute('data-key'), 10);
    const hasCellNumber = !Number.isNaN(cellNumber);
    let onEditCellClicked;
    if (hasCellNumber && editConfig && typeof editConfig.onEditCellClicked === 'function') {
        // resolve closest (e.g. for dropdowns) usable id of a clicked element inside a cell
        const idElement = target.closest('[id]');
        const elementId = idElement && cell.contains(idElement) ? idElement.getAttribute('id') || null : null;
        if (!elementId) {
            showIdWarnings(row, target);
        }
        onEditCellClicked = () => {
            editConfig.onEditCellClicked(event, row, Object.assign(Object.assign({}, rowProps), { columnIndex: cellNumber, elementId }));
        };
    }
    // give priority to fire onChange/onBlur callbacks
    setTimeout(() => {
        if (!row.isEditing) {
            onRowClick(event, row, rowProps, computedData);
            if (onEditCellClicked) {
                // edit cell after rerender
                setTimeout(onEditCellClicked, 0);
            }
        }
        else if (onEditCellClicked) {
            onEditCellClicked();
        }
    }, 0);
};
export const Body = (_a) => {
    var { BodyComponent, rows = [], editConfig, onRowClick = () => { } } = _a, props = __rest(_a, ["BodyComponent", "rows", "editConfig", "onRowClick"]);
    const isTableEditing = rows.some(row => row.isEditing);
    const mappedRows = rows.map(row => (Object.assign(Object.assign({}, row), { editConfig,
        isTableEditing })));
    resolveCascadeEditability(mappedRows);
    return (React.createElement(BodyComponent, Object.assign({}, props, { rows: mappedRows, onRowClick: (event, row, rowProps, computedData) => onRow(event, row, rowProps, computedData, { onRowClick, editConfig }) })));
};
//# sourceMappingURL=Body.js.map